import { Zap } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface TokenUsageProps {
  usage: {
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
  };
  model?: string;
}

export function TokenUsage({ usage, model }: TokenUsageProps) {
  return (
    <div className="mt-1 flex items-center gap-2 text-xs text-muted-foreground">
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="flex items-center gap-1 tabular-nums cursor-default">
            <Zap className="h-3 w-3" />
            {usage.totalTokens.toLocaleString()} tokens
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {usage.promptTokens.toLocaleString()} prompt +{" "}
            {usage.completionTokens.toLocaleString()} completion
          </p>
        </TooltipContent>
      </Tooltip>
      {model && <span>· {model}</span>}
    </div>
  );
}
